import { render, staticRenderFns } from "./DefaultImageBox.vue?vue&type=template&id=67a29a98&scoped=true"
import script from "./DefaultImageBox.vue?vue&type=script&lang=js"
export * from "./DefaultImageBox.vue?vue&type=script&lang=js"
import style0 from "./DefaultImageBox.vue?vue&type=style&index=0&id=67a29a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a29a98",
  null
  
)

export default component.exports